export function deferJQuery(method: (jQuery: WindowJQuery) => void) {
	if (window.jQuery) {
		method(window.jQuery);
	} else {
		setTimeout(() => {
			deferJQuery(method);
		}, 100);
	}
}
